<template>
  <div class="flex gap-4">
    <LazyFrontendServiceFilterToggleableToggle v-if="toggleable" filter-id="national-support-only" />
    <UFormGroup
      v-if="toggleable || !disabledFilters.includes('national-support-only')"
      class="flex gap-4 items-center"
      :ui="{ hint: 'flex items-center ml-2', label: { base: 'text-base font-bold font-brown' } }"
    >
      <template #label> National Support Only </template>
      <template #hint>
        <HTooltip
          text="Only show services that offer support across the UK. National support services are available consistently throughout the country, ensuring access to mental health support for everyone, regardless of where you live."
          :ui="{
            position: 'right',
            base: 'text-wrap',
            width: 'max-w-3xl'
          }"
        >
          <UIcon name="heroicons:information-circle-20-solid" size="16" class="bg-blue" />
        </HTooltip>
      </template>
      <UToggle
        v-model="filters.national"
        color="green"
        on-icon="i-heroicons-check-20-solid"
        off-icon="i-heroicons-x-mark-20-solid"
        aria-label="National Support only toggle"
      />
    </UFormGroup>
  </div>
</template>
<script setup lang="ts">
const store = useServiceSearchStore()
const { filters, disabledFilters } = storeToRefs(store)
defineProps({
  toggleable: Boolean
})
</script>
